import { Link } from "@tanstack/react-router";

interface LegalLinksProps {
  className?: string;
  /** Open in a new tab so an in-progress dialog is not lost. */
  newTab?: boolean;
}

const linkClass =
  "text-sm text-warm-text-secondary hover:text-warm-text-primary transition-colors";

export default function LegalLinks({
  className = "",
  newTab = false,
}: LegalLinksProps) {
  const extra = newTab
    ? { target: "_blank" as const, rel: "noopener noreferrer" }
    : {};

  return (
    <nav
      aria-label="Legal"
      className={`flex flex-wrap items-center gap-4 ${className}`.trim()}
    >
      <Link to="/terms" className={linkClass} {...extra}>
        Terms of Service
      </Link>
      <Link to="/privacy" className={linkClass} {...extra}>
        Privacy Policy
      </Link>
      <Link to="/account-deletion" className={linkClass} {...extra}>
        How to delete
      </Link>
    </nav>
  );
}
